import { Component, OnInit } from '@angular/core';
import { InstructorModel } from '@bayclubs/group-classes-employee-api';

@Component({
    selector: 'app-select-instructor',
    templateUrl: './select-instructor.component.html',
    styleUrls: ['./select-instructor.component.scss'],
    standalone: false
})
export class SelectInstructorComponent implements OnInit {
    clubId: string;
    public selectedInstructorModel: InstructorModel;
    copyClass: boolean;
    close: Function;
    constructor() {}

    ngOnInit(): void {}

    public onInstructorSelectedSelected(item: InstructorModel): void {
        this.selectedInstructorModel = item;
    }

    public onClose() {
        this.copyClass = false;
        this.close();
    }

    public onSave() {
        this.copyClass = true;
        this.close();
    }
}
